import { Suspense, lazy } from 'react';
import CoordMap from './CoordMap';
import type { RoutePoint, Stop, TrackEvent, LivePerson, DayCustomer } from './types';

/**
 * Picks the renderer. When a tile style is configured the console shows
 * real streets (TileMap, lazily loaded so MapLibre is downloaded only
 * then); otherwise the coordinate renderer, which needs no key and works
 * offline. Same data either way.
 */
// A street basemap now always renders: VITE_MAP_STYLE_URL when set,
// otherwise OpenFreeMap's free keyless style (see TileMap). CoordMap
// remains the code path only if this is ever forced off.
const hasTiles = (import.meta.env.VITE_MAP_STYLE_URL as string | undefined) !== '';
const TileMap = lazy(() => import('./TileMap'));

type Props =
  | {
      mode: 'route';
      path: RoutePoint[]; stops: Stop[]; events: TrackEvent[]; customers?: DayCustomer[];
      scrubFrac: number; highlightStop?: number | null; onStopClick?: (i: number) => void;
    }
  | { mode: 'live'; people: LivePerson[]; selectedId: string | null; onSelect: (id: string) => void };

export default function MapView(props: Props) {
  if (hasTiles) {
    const tileProps = props.mode === 'route'
      ? { mode: 'route' as const, path: props.path, stops: props.stops, events: props.events, customers: props.customers, scrubFrac: props.scrubFrac, highlightStop: props.highlightStop, onStopClick: props.onStopClick }
      : props;
    return (
      <Suspense fallback={<div className="tk-maploading">Loading map…</div>}>
        <TileMap {...tileProps} />
      </Suspense>
    );
  }
  return <CoordMap {...props} />;
}

export { hasTiles };
